import React from 'react';

import { type DeviceOrientationType, useDeviceOrientation } from '../hooks';
import createContextFactory from './createContextFactory';

export type DeviceOrientationContextProps = {
  setFixedAppLayoutContent: (fixed: boolean) => void;
  deviceOrientation: DeviceOrientationType;
  isFixedAppLayoutContent: boolean;
};
const DeviceOrientationContext = createContextFactory({
  devToolsName: 'DeviceOrientationContext',
  initialValue: {} as DeviceOrientationContextProps,
});

export function useDeviceOrientationContext() {
  return DeviceOrientationContext.useContext();
}

export function DeviceOrientationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    deviceOrientation,
    isFixedAppLayoutContent,
    setFixedAppLayoutContent,
  } = useDeviceOrientation();

  const providedValue = React.useMemo(() => {
    return {
      deviceOrientation,
      isFixedAppLayoutContent,
      setFixedAppLayoutContent,
    };
  }, [deviceOrientation, setFixedAppLayoutContent, isFixedAppLayoutContent]);
  return (
    <DeviceOrientationContext.Provider value={providedValue}>
      {children}
    </DeviceOrientationContext.Provider>
  );
}
